var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-3xl font-bold dark:text-white",class:{
    'text-yellow-600': _vm.value === 1,
    'text-gray-600': _vm.value > 1,
  },style:(_vm.color && 'color: ' + _vm.color)},[_vm._v(" "+_vm._s(_vm.value)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }